<mat-card appearance="outlined">
	<mat-card-header>
		<mat-card-title>{{ 'BOOKINGS.comments' | translate | capitalize }}</mat-card-title>
	</mat-card-header>
	<mat-card-content class="mat-card-content">
		<form [formGroup]="formBookingComments" autocomplete="off">
			<div style="display: flex; gap: 20px">
				<mat-form-field appearance="outline" style="width: 380px">
					<mat-label>{{ 'BOOKINGS.comments' | translate | capitalize }}</mat-label>
					<textarea cdkTextareaAutosize matInput cdkAutosizeMinRows="1" formControlName="comments"></textarea>
				</mat-form-field>
			</div>
			<app-tag-autocomplete
				[tagType]="'booking'"
				[alreadyAssignedTags]="booking.tags"
				(selectedTagsEvent)="setTags($event)"
			></app-tag-autocomplete>
		</form>
	</mat-card-content>
	<mat-card-actions class="mat-card-actions">
		<button mat-flat-button (click)="save(formBookingComments.value)">
			{{ 'APPLICATION.save' | translate | capitalize }}
		</button>
		<button mat-stroked-button (click)="cancel(formBookingComments.value)">{{ 'APPLICATION.cancel' | translate | capitalize }}</button>
	</mat-card-actions>
</mat-card>
